import { render } from "./InnerTable.vue?vue&type=template&id=58635869&scoped=true"
import script from "./InnerTable.vue?vue&type=script&lang=js"
export * from "./InnerTable.vue?vue&type=script&lang=js"

import "./InnerTable.vue?vue&type=style&index=0&id=58635869&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58635869"]])

export default __exports__